import throttle from 'lodash/throttle';

export class Header {
  constructor() {
    this.slimClass = 'is-slim';
    this.header = document.querySelector('[data-header]');
    if (this.header === null) {
      return;
    }
    this.init();
  }

  init() {
    this.resizeHeaderHeight();
    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('scroll', throttle(() => {
      this.resizeHeaderHeight();
    }, 150));
  }

  resizeHeaderHeight() {
    if (window.scrollY >= 96) {
      this.header.classList.add(this.slimClass);
    } else {
      this.header.classList.remove(this.slimClass);
    }
  }

}
document.addEventListener("DOMContentLoaded", function() {
  new Header();
});
